export class BucketNotificationProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sampledCount",
            "baseName": "sampledCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampleMessages",
            "baseName": "sampleMessages",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "observedPaths",
            "baseName": "observedPaths",
            "type": "Array<JsonPathSample>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BucketNotificationProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
